import React from "react";

export const NotFound = ({ description }: { description: string }) => {
  return (
    <div className="flex items-center justify-center h-64 border bg-white/50 dark:border-neutral-6000 dark:bg-neutral-950/50 rounded-lg">
      <p className="text-gray-500 dark:text-white">{description}</p>
    </div>
  );
};
